<template>
    <div class="home">
        <div class="header">
            <el-affix :offset="0">
                <div class="hidden-xs-only defaultTitle">
                    <img style="width: 49px" src="../../assets/logo.png" />
                    <el-anchor :offset="28" direction="horizontal">
                        <el-anchor-link href="#module1">
                            首页
                        </el-anchor-link>
                        <el-anchor-link href="#module2">
                            产品
                        </el-anchor-link>
                        <el-anchor-link href="#module4">
                            客户案例
                        </el-anchor-link>
                        <el-anchor-link href="#module5">
                            关于我们
                        </el-anchor-link>
                    </el-anchor>
                </div>
                <div class="hidden-sm-and-up">
                    <el-anchor :offset="28" @click="navigationOpenState = false" >
                        <div class="smallTitle">
                            <img style="width: 49px;" src="../../assets/logo.png" />

                            <el-icon size="30" color="#000" class="menuIcon"
                                :style="{ transform: navigationOpenState ? 'rotate(-90deg)' : 'rotate(270deg)'}"
                                @click="navigationOpenState = !navigationOpenState">
                                <Menu />
                            </el-icon>
                        </div>

                        <div v-if="navigationOpenState">
                            <el-anchor-link href="#module1">
                                首页
                            </el-anchor-link>
                            <el-anchor-link href="#module2">
                                产品
                            </el-anchor-link>
                            <el-anchor-link href="#module4">
                                客户案例
                            </el-anchor-link>
                            <el-anchor-link href="#module5">
                                关于我们
                            </el-anchor-link>
                        </div>
                    </el-anchor>
                </div>
            </el-affix>
        </div>
        <div id="module1">
            <module1 />
        </div>
        <div id="module2">
            <module2 />
        </div>
        <!-- <div id="module3" style="height: 500px;background-color: #ff0;">
            <module3 />
        </div> -->
        <div id="module4">
            <module4 />
        </div>
        <div id="module5">
            <module5 />
        </div>
        <a class="beian" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">由智慧家园提供技术支持
            备案号：陕ICP备2022001360号</a>

        <!-- <el-row :gutter="0">
                    <el-col :xs="3" :sm="6" :md="4" :lg="3" :xl="1">
                    </el-col>
                    <el-col :xs="3" :sm="6" :md="4" :lg="3" :xl="1">
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1">
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1">
                    </el-col>
                    <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1">
                    </el-col>
                </el-row> -->
    </div>
</template>

<script setup lang="ts">
import { ClickOutside as vClickOutside } from 'element-plus';
import 'element-plus/theme-chalk/display.css'
import module1 from './components/module1.vue'
import module2 from './components/module2.vue'
import module3 from './components/module3.vue'
import module4 from './components/module4.vue'
import module5 from './components/module5.vue'
import { ref } from 'vue'

let navigationOpenState = ref(false)
const handleSelect = (key: string, keyPath: string[]) => {

}
</script>
<style lang="scss" scoped>
.home {
    color: #fff;

    ::v-deep .header {

        .el-affix--fixed{
            width: 100%;
        }
        .el-anchor {
            background-color: #fff;
            flex: 1;
        }

        .el-anchor .el-anchor__list .el-anchor__item a {
            color: #000;
            font-size: 17px;
            padding: 13px 42px;
        }

        .el-anchor__link.is-active {
            background: #409eff;
            color: #fff !important;
        }

        .el-anchor.el-anchor--horizontal .el-anchor__marker {
            display: none;
        }

        .el-anchor.el-anchor--horizontal .el-anchor__list .el-anchor__item {
            padding-left: 0;
        }

        .el-anchor.el-anchor--horizontal .el-anchor__list {
            padding-bottom: 0;
        }

        .el-anchor.el-anchor--vertical .el-anchor__marker {
            width: 0;
        }

        .el-anchor.el-anchor--vertical .el-anchor__list{
            padding: 0;
        }

        .defaultTitle {
            display: flex;
            align-items: center;
        }

        .smallTitle {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 10px;
            .menuIcon{
                cursor: pointer;
                transition: transform 0.5s ease-in-out;
            }
        }
    }

    .beian {
        color: #fff;
        background: #363636;
        width: 100%;
        display: inline-block;
        text-align: center;
        padding: 20px 0;
        text-decoration: none;
    }
}
</style>